var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('main',{key:_vm.key,staticClass:"flex flex-col overflow-scroll border-gray-200 border rounded-2xl p-2 bg-white"},[(_vm.users == null)?_c('div',{staticClass:"flex"},[_vm._v("\n            Loading organization data....\n        ")]):_c('div')])])
}
var staticRenderFns = []

export { render, staticRenderFns }